import {useFormContext} from "react-hook-form";
import React from "react";
import {useTranslation} from "react-i18next";
import { NFLookupProduct } from "src/components/Shared/NewForms/NFLookupProduct";
import { NFormTable } from "src/components/Shared/NewForms/NFormTable";
import {NFPlainText} from "src/components/Shared/NewForms/NFPlainText";
import {NFLookupUnit} from "src/components/Shared/NewForms/NFLookupUnit";
import {NFLookupInput} from "src/components/Shared/NewForms/NFLookupInput";
import {VatTypeEnum} from "src/enums/VatTypeEnum";
import {AmountHelper} from "src/helpers/AmountHelper";
import {EnumHelper} from "src/helpers/EnumHelper";
import {NFIntInput} from "src/components/Shared/NewForms/NFIntInput";

export const PurchaseOrderDetailServices = () => {
    const tableName = "services";
    const {setValue, getValues} = useFormContext();
    const {t} = useTranslation();

    const handleVatTypeChanged = (newVatType: VatTypeEnum, index: number) => {
        setValue(
            `${tableName}.${index}.vatAmount`,
            AmountHelper.getVatAmount(
                newVatType,
                getValues(`${tableName}.${index}.amount`),
                getValues("priceIncludesVat")
            )
        );
    };

    const handleQuantityChanged = (newQuantity: number, index: number) => {
        const newAmounts = AmountHelper.getNewAmountsAfterQuantityPriceChanged(
            newQuantity,
            getValues(`${tableName}.${index}.price`),
            getValues(`${tableName}.${index}.vatType`),
            getValues("priceIncludesVat")
        );
        setValue(`${tableName}.${index}.amount`, newAmounts.amount);
        setValue(`${tableName}.${index}.vatAmount`, newAmounts.vatAmount);
        setValue(
            `${tableName}.${index}.amountWithVat`,
            newAmounts.amountWithVat
        );
    };

    const handlePriceChanged = (newPrice: number, index: number) => {
        const newAmounts = AmountHelper.getNewAmountsAfterQuantityPriceChanged(
            getValues(`${tableName}.${index}.quantity`),
            newPrice,
            getValues(`${tableName}.${index}.vatType`),
            getValues("priceIncludesVat")
        );
        setValue(`${tableName}.${index}.amount`, newAmounts.amount);
        setValue(`${tableName}.${index}.vatAmount`, newAmounts.vatAmount);
        setValue(
            `${tableName}.${index}.amountWithVat`,
            newAmounts.amountWithVat
        );
    };

    return (
        <>
            <NFormTable fieldArray={tableName}>
                <NFLookupProduct
                    title={t("Product")}
                    fieldName="productId"
                    modelField="productModel"
                    width={200}
                />
                <NFPlainText
                    title={t("vendorCode")}
                    fieldName="productId"
                    modelField="productModel"
                    width={200}
                />
                <NFLookupUnit
                    title={t("Unit")}
                    fieldName="unitId"
                    width={200}
                    required={true}
                />
                <NFLookupInput
                    title={t("Taxation")}
                    fieldName="vatTaxationType"
                    items={EnumHelper.GetVatTaxationTypeArrayForLookup()}
                    width={150}
                />
                <NFLookupInput
                    title={t("VatType")}
                    fieldName="vatType"
                    items={EnumHelper.GetVatTypeArrayForLookup()}
                    width={150}
                    onValueChange={handleVatTypeChanged}
                />
                <NFIntInput
                    fieldName="quantity"
                    title={t("Quantity")}
                    onValueChanged={handleQuantityChanged}
                    width={100}
                />
                <NFIntInput
                    fieldName="price"
                    title={t("Price")}
                    onValueChanged={handlePriceChanged}
                    width={100}
                />
                <NFIntInput title={t("Amount")} fieldName="amount"/>
                <NFIntInput
                    title={t("amountWithVat")}
                    fieldName="amountWithVat"
                />
                <NFIntInput title={t("vatAmount")} fieldName="vatAmount"/>
            </NFormTable>
        </>
    );
};
